import styled from "styled-components";

const StylesContainer = styled.div`
  header {
    margin-bottom: 40px;

    h3 {
      color: #1e1919;
      font-size: 15px;
      margin: unset;
    }
  }

  .ant-table-wrapper {
    .ant-table-thead > tr > * {
      font-weight: 500;
      background: transparent;

      &::before {
        display: none;
      }
    }

    tr > td.assets-column,
    tr > th.assets-column {
      background: #f6f7f8;
    }
  }
`;

export default StylesContainer;
